<template>
  <div id="OrgDetailInfo" :class="orgInfo.authStatus=='1'?'autoStatus':''">
    <div v-if="orgInfo.authStatus == '1'" class="auth-div">
      <div class="auth-div-title">企业信息</div>
      <div class="auth-div-desc">已认证</div>
    </div>
    <eb-panel>
      <eb-panel-header class="panel-header" slot="header">
        <span slot="title">
          <span style="float: left;width: 22.8%;">企业信息</span>
          <span v-if="orgInfo.departType==1 || orgInfo.departType==3" slot="button" style="color: #fb5b3b;">{{departRealNameInfo(orgInfo.authStatus)}}</span>
          <el-button @click="viewRealName" v-if="(user.roleid==2 || user.roleid==12) && orgInfo.authStatus!=1 && orgInfo.authStatus!=2" slot="button" class="viewRealName el-button el-button eb-button-orange eb-button-small el-button--default" style="float: right;">申请实名认证</el-button>
        </span>
      </eb-panel-header>
      <div slot="body">
        <div class="panel-body-row">
          <div class="panel-body-row-left">统一社会信用代码:</div>
          <div class="panel-body-row-right">{{orgInfo.creditCode}}</div>
        </div>
        <div class="panel-body-row">
          <div class="panel-body-row-left">企业名称:</div>
          <div class="panel-body-row-right">{{orgInfo.departName}}</div>
        </div>
        <div class="panel-body-row">
          <div class="panel-body-row-left ">类型:</div>
          <div class="panel-body-row-right">{{orgInfo.orgType}}</div>
        </div>
        <div class="panel-body-row">
          <div class="panel-body-row-left ">法定代表人:</div>
          <div class="panel-body-row-right">{{orgInfo.legalPerson}}</div>
        </div>
        <div class="panel-body-row">
          <div class="panel-body-row-left ">注册资本:</div>
          <div class="panel-body-row-right">{{orgInfo.registerCapital}}</div>
        </div>
        <div class="panel-body-row">
          <div class="panel-body-row-left ">成立日期:</div>
          <div class="panel-body-row-right">{{orgInfo.foundingDate | dateFormatYMD }}</div>
        </div>
        <div class="panel-body-row">
          <div class="panel-body-row-left ">营业期限自:</div>
          <div class="panel-body-row-right">{{orgInfo.busiTermStart | dateFormatYMD}}</div>
        </div>
        <div class="panel-body-row">
          <div class="panel-body-row-left ">营业期限至:</div>
          <div class="panel-body-row-right">{{orgInfo.busiTermEnd | dateFormatYMD}}</div>
        </div>
        <div class="panel-body-row">
          <div class="panel-body-row-left ">登记机关:</div>
          <div class="panel-body-row-right">{{orgInfo.regOffice}}</div>
        </div>
        <div class="panel-body-row">
          <div class="panel-body-row-left ">核准日期:</div>
          <div class="panel-body-row-right">{{orgInfo.approvalDate | dateFormatYMD}}</div>
        </div>
        <div class="panel-body-row">
          <div class="panel-body-row-left ">登记状态:</div>
          <div class="panel-body-row-right">{{orgInfo.regStatus}}</div>
        </div>
        <div class="panel-body-row">
          <div class="panel-body-row-left ">注册地址:</div>
          <div class="panel-body-row-right">{{orgInfo.registerAddress}}</div>
        </div>
        <div class="panel-body-row">
          <div class="panel-body-row-left ">经营范围:</div>
          <div class="panel-body-row-right">{{orgInfo.busiScope}}</div>
        </div>
        <div class="panel-body-row">
          <div class="panel-body-row-left ">营业执照:</div>
          <div class="panel-body-row-right">
            <div class="org-info-busi-license" :data-img-preview-src="businessLicenseImgUrl" v-image-preview>
              <span style="position:relative">
                <img style="margin:auto;max-width:100%;max-height:100%;height:auto;width: auto; cursor: pointer;" :src="businessLicenseImgUrl">
                <img v-show="orgInfo.authStatus=='1'" style="position:absolute;height:20px;width:20px;top:0;left:0" :src="$ebConfig.imgPath+'img/authstatus.png'" alt="">
              </span>
            </div>
          </div>
        </div>
      </div>
    </eb-panel>
  </div>
</template>
<script>
import ebPanel from '@/components/common/panel/eb-panel';
import ebPanelHeader from '@/components/common/panel/eb-panel-header';
import { imagePreview } from '@/directives/image-preview';
import { baseURL } from '@/plugins/axios';
export default {
  name: 'OrgDetailInfo',
  props: {
    orgInfo: {},
    user: {}
  },
  data() {
    return {
      baseURL: baseURL
    };
  },
  components: {
    ebPanel,
    ebPanelHeader
  },
  directives: {
    imagePreview: imagePreview
  },
  computed: {
    businessLicenseImgUrl() {
      return this.orgInfo.businessLicense ? baseURL + this.orgInfo.businessLicense : baseURL + '/static/img/147x147.png';
    }
  },
  methods: {
    departRealNameInfo(authStatus) {
      let roleId = this.user.roleid;
      if (authStatus === '1') {
        return this.$options.filters['orgAuthStatus'](authStatus);
      } else if (authStatus === '2') {
        return this.$options.filters['orgAuthStatus'](authStatus);
      } else {
        if (roleId === '2' || roleId === '8' || roleId === '9') {
          return this.$options.filters['orgAuthStatus'](authStatus);
        } else {
          return '未实名认证';
        }
      }
    },
    async viewRealName() {
      this.$router.push('/org/edit/');
    },
    getBusinessLicenseImgUrl() {}
  }
};
</script>
<style scoped lang="less">
.autoStatus {
  background: url('../../../assets/img/autostatus_bg.jpg');
  overflow: hidden;
  border: 1px solid #fb5b3b;
  box-shadow: 5px 5px 5px #ccc;
  position: relative;
}
#OrgDetailInfo {
  .auth-div {
    position: absolute;
    right: -52px;
    top: 39px;
    height: 50px;
    width: 234px;
    background: #fb5b3b;
    transform: rotate(45deg);
    .auth-div-title {
      text-align: center;
      color: #fff;
      padding-top: 5px;
    }
    .auth-div-desc {
      text-align: center;
      color: #fff;
    }
  }
  .org-info-busi-license {
    display: flex;
    height: 109px;
    width: 109px;
    margin-top: 10px;
    float: left;
    border: 1px solid #cccccc;
  }
  .viewRealName {
    width: 100px;
  }
}
</style>
